import { takeLatest, put } from "redux-saga/effects";
import { createReducer, makeAction, makeKeys } from "./helper";
import { httpGet } from "../core/restClient";
import { appLoading, appLoaded } from './app'

const GET_HRMS_MEMBERS = makeKeys("GET_HRMS_MEMBERS");
const ADD_OTHER_MEMBER = "ADD_OTHER_MEMBER";
const GET_PURCHASE_USERS = makeKeys("GET_PURCHASE_USERS");
const GET_USER_BY_ROLE = makeKeys("GET_USER_BY_ROLE");
const GET_ROLE_BY_USER = makeKeys("GET_ROLE_BY_USER");
const GET_ALL_MEMBERS = makeKeys("GET_ALL_MEMBERS");
const GET_LIST_ROLE_K2 = makeKeys('GET_LIST_ROLE_K2')
const CLEAR_SEARCH_ROLE_K2 = "CLEAR_SEARCH_ROLE_K2"

export const getHrmsMembers = makeAction(
  GET_HRMS_MEMBERS.REQUEST,
  "includeInActive",
  "callBack"
);
export const addOtherMember = makeAction(ADD_OTHER_MEMBER);
export const getPurchaseUsers = makeAction(
  GET_PURCHASE_USERS.REQUEST,
  "companyCode",
  "purchGroup"
);
export const getUserByRole = makeAction(
  GET_USER_BY_ROLE.REQUEST,
  "role",
  "onSuccess"
);
export const getRoleByUser = makeAction(
  GET_ROLE_BY_USER.REQUEST,
  "username",
  "onSuccess"
);
export const getAllMembers = makeAction(
  GET_ALL_MEMBERS.REQUEST,
  "includeInActive",
  "callBack"
);
export const getListRoleK2 = makeAction(GET_LIST_ROLE_K2.REQUEST);
export const clearSearchRoleK2 = makeAction(CLEAR_SEARCH_ROLE_K2);

const getHrmsMembersSuccess = makeAction(GET_HRMS_MEMBERS.SUCCESS, "data");
const getPurchaseUsersSuccess = makeAction(GET_PURCHASE_USERS.SUCCESS, "data");
const getUserByRoleSuccess = makeAction(GET_USER_BY_ROLE.SUCCESS, "data");
const getRoleByUserSuccess = makeAction(GET_ROLE_BY_USER.SUCCESS, "data");
const getAllMembersSuccess = makeAction(GET_ALL_MEMBERS.SUCCESS, "data");
const getListRoleK2Success = makeAction(GET_LIST_ROLE_K2.SUCCESS, "data");

const initial = {
  memberLoading: false,
  members: [],
  purchaseUsers: { data: [], loading: false },
  membersSelectView: [],
  userByRole: [],
  roleByUser: [],
  listRoleK2: [],
  listRoleK2Loading: false
};

function* getHrmsMembersRequest(action) {
  const { includeInActive, callBack } = action.payload;
  let response;
  try {
    if (includeInActive == true) {
      //เอา user ที่ลาออกไปแล้วรวมมาด้วย
      response = yield httpGet("members/hrms", {
        includeUnActive: includeInActive,
      });
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getHrmsMembersSuccess(response.data));
          if (callBack !== null) callBack(response.data);
        }
      }
    } else {
      response = yield httpGet("members/hrms");
      console.log("response get active member ", response);
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getHrmsMembersSuccess(response.data));
          if (callBack !== null) callBack(response.data);
        }
      }
    }
    // const response = yield httpGet('members/hrms')
    // if (response.status >= 200 && response.status < 300) {
    //   if (response.data) {
    //     yield put(getHrmsMembersSuccess(response.data))
    //     if (callBack !== null) callBack(response.data)
    //   }
    // }
  } catch (e) {}
}

function* getPurchaseUsersRequest(action) {
  const { companyCode, purchGroup } = action.payload;
  try {
    const response = yield httpGet(
      `members/roleOfficerPurchaseUsers/${companyCode}/${purchGroup}`
    );
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPurchaseUsersSuccess(response.data));
      }
    }
  } catch (e) {
    yield put(getPurchaseUsersSuccess([]));
  }
}

function* getUserByRoleRequest(action) {
  const { role, onSuccess } = action.payload;
  
  try {
    yield put(appLoading("Search User..."));
    const response = yield httpGet(`members/userByRole/${role}`);
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getUserByRoleSuccess(response.data));
        // onSuccess();
      }
    }
  } catch (e) {
    yield put(getUserByRoleSuccess([]));
  }
}

function* getRoleByUserRequest(action) {
  const { username, onSuccess } = action.payload;
  try {
    yield put(appLoading("Search Role..."));
    const response = yield httpGet(`members/RoleByUser/${username}`);
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getRoleByUserSuccess(response.data));
        // onSuccess();
      }
    }
  } catch (e) {
    yield put(getRoleByUserSuccess([]));
  }
}

function* getAllMembersRequest(action) {
  const { includeInActive, callBack } = action.payload;
  let response;
  try {
    if (includeInActive == true) {
      //เอา user ที่ลาออกไปแล้วรวมมาด้วย
      response = yield httpGet("members", {
        includeUnActive: includeInActive,
      });
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getAllMembersSuccess(response.data));
          if (callBack !== null) callBack(response.data);
        }
      }
    } else {
      response = yield httpGet("members");
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getAllMembersSuccess(response.data));
          if (callBack !== null) callBack(response.data);
        }
      }
    }
  } catch (e) {}
}

function* getListRoleK2Request(action) {
  try {
    const response = yield httpGet(`members/k2Roles`);
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getListRoleK2Success(response.data));
      }
    }
  } catch (e) {
    yield put(getListRoleK2Success([]));
  }
}

export function* watchMembersSaga() {
  yield takeLatest(GET_HRMS_MEMBERS.REQUEST, getHrmsMembersRequest);
  yield takeLatest(GET_PURCHASE_USERS.REQUEST, getPurchaseUsersRequest);
  yield takeLatest(GET_USER_BY_ROLE.REQUEST, getUserByRoleRequest);
  yield takeLatest(GET_ROLE_BY_USER.REQUEST, getRoleByUserRequest);
  yield takeLatest(GET_ALL_MEMBERS.REQUEST, getAllMembersRequest);
  yield takeLatest(GET_LIST_ROLE_K2.REQUEST, getListRoleK2Request);
}

export default createReducer(initial, (state) => ({
  [GET_HRMS_MEMBERS.REQUEST]: () => ({
    ...state,
    memberLoading: true,
  }),
  [GET_HRMS_MEMBERS.SUCCESS]: (data) => ({
    ...state,
    members: data.data,
    memberLoading: false,
  }),
  [GET_PURCHASE_USERS.REQUEST]: () => ({
    ...state,
    purchaseUsers: { data: [], loading: true },
  }),
  [GET_PURCHASE_USERS.SUCCESS]: (data) => ({
    ...state,
    purchaseUsers: { data: data.data, loading: false },
  }),
  [ADD_OTHER_MEMBER]: (data) => ({
    ...state,
    members: [
      ...state.members,
      {
        username: data,
        firstnameEn: data,
        lastnameEn: "",
        companyCode: 320,
        costCenterCode: "",
        mainDepartmentEn: "",
      },
    ],
  }),
  [GET_USER_BY_ROLE.REQUEST]: () => ({
    ...state,
    userByRole: { data: [], loading: true },
  }),
  [GET_USER_BY_ROLE.SUCCESS]: (data) => ({
    ...state,
    userByRole: { data: data.data, loading: false },
  }),
  [GET_ROLE_BY_USER.REQUEST]: () => ({
    ...state,
    roleByUser: { data: [], loading: true },
  }),
  [GET_ROLE_BY_USER.SUCCESS]: (data) => ({
    ...state,
    roleByUser: { data: data.data, loading: false },
  }),
  [GET_ALL_MEMBERS.REQUEST]: () => ({
    ...state,
    memberLoading: true,
  }),
  [GET_ALL_MEMBERS.SUCCESS]: (data) => ({
    ...state,
    members: data.data,
    memberLoading: false,
  }),
  [GET_LIST_ROLE_K2.REQUEST]: () => ({
    ...state,
    listRoleK2: [],
    listRoleK2Loading: true,
  }),
  [GET_LIST_ROLE_K2.SUCCESS]: (data) => ({
    ...state,
    listRoleK2: data.data,
    listRoleK2Loading: false,
  }),
  [CLEAR_SEARCH_ROLE_K2]: () => ({
    ...state,
    userByRole: [],
    roleByUser: []
  }),
}));
